import React, { Fragment } from 'react';

const CompanyCreatePost = () => {
  return (
    <Fragment>
      <div className="create-post-avi-text">
        <div className="create-post-avi-container">
          <div className="company-create-post-avi"></div>
        </div>
        <div className="create-post-text-container">
          <textarea
            className="create-post-text"
            name="posttext"
            placeholder="What would you like to say?"
          ></textarea>
        </div>
      </div>
      <div className="create-post-button-container">
        <button className="create-post-button background-blue">
          <i className="far fa-edit mx-5"></i>Create Post
        </button>
      </div>
    </Fragment>
  );
};

export default CompanyCreatePost;
